module.exports = __webpack_public_path__ + "static/logo-acfd2faf2bd380650fe85bf83ef3c8e2.png";